import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MealItem from "./pages/setting/meal-item/MealItem";
import DashboardLayout from "./components/layout/mainComponent/Main";
import Analytics from "./pages/analytics/Analytics";
import SettingMeal from "./pages/setting/meal/SettingMeal";
// import Inventory from "./pages/setting/inventory-management/Inventory";
// import MealTimeline from "./pages/meal-timeline/MealTimeline";
import Registration from "./pages/registration/Registration";
import CardScannerPage from "./pages/CardScannerPage";
import Login from "./pages/Login";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<DashboardLayout />}>
          <Route path="/analytics" element={<Analytics />} />
          {/* <Route path="/meal-timeline" element={<MealTimeline />} /> */}
          <Route path="/rfid-registration" element={<Registration />} />
          <Route path="/card-scanner" element={<CardScannerPage />} />
          <Route path="/setting/meals" element={<SettingMeal />} />
          <Route path="/setting/menu" element={<MealItem />} />
          {/* <Route path="/setting/inventory-management" element={<Inventory />} /> */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
